import { setCookie, getCookie, removeCookie } from 'tiny-cookie'
import { OPERATIONS_BACKEND_URL, VUE_APP_TMS_DOMAIN } from '@/config'
import { isLocalhost } from '@/environment-detection'
import {
  runUnauthenticatedJsonGet,
  runUnauthenticatedJsonPost,
  runJsonPost
} from '@/backend-client'

const AUTH_TOKEN_COOKIE_NAME = 'auth_token'

const getDomain = () => (isLocalhost() ? '' : VUE_APP_TMS_DOMAIN)

export function removeAuthCookie() {
  removeCookie(AUTH_TOKEN_COOKIE_NAME, { domain: getDomain() })
}

export function clearSessionStorage() {
  localStorage.clear()
}

export async function login(credentials) {
  const { data } = await runUnauthenticatedJsonPost(
    `${OPERATIONS_BACKEND_URL}/auth/login/`,
    credentials
  )
  setCookie(AUTH_TOKEN_COOKIE_NAME, data.key, { expires: '7D', domain: getDomain() })
}

export async function logout() {
  await runJsonPost(`${OPERATIONS_BACKEND_URL}/auth/logout/`, {})
  removeAuthCookie()
  clearSessionStorage()
}

export function isLoggedIn() {
  // If the cookie has expired the token will we automatically empty
  return Boolean(getCookie(AUTH_TOKEN_COOKIE_NAME))
}

export function getAuthCookie() {
  return getCookie(AUTH_TOKEN_COOKIE_NAME)
}

export const checkBackendHealth = async () => {
  await runUnauthenticatedJsonGet(`${OPERATIONS_BACKEND_URL}/health/`)
}

export const acceptCookies = async cookies => {
  await runJsonPost(`${OPERATIONS_BACKEND_URL}/accounts/commands/accept-cookies`, cookies)
}
